export const GET_DIETARY_STATISTICS = 'GET_DIETARY_STATISTICS'
export const GET_DIETARY_STATISTICS_SUCCESS = 'GET_DIETARY_STATISTICS_SUCCESS'
export const GET_DIETARY_STATISTICS_FAILED = 'GET_DIETARY_STATISTICS_FAILED'
